export enum ReplyOrder {
  Like = 'Like',
  Latest = 'Latest',
  Created = 'Created',
}

export const ReplyOrderText = {
  [ReplyOrder.Like]: '좋아요순',
  [ReplyOrder.Latest]: '최신순',
  [ReplyOrder.Created]: '등록순',
} satisfies Record<ReplyOrder, string>;

export enum ReplyErrorCodes {
  ReportAlreadyExist = 'ReportAlreadyExist',
  RestrictWriteReplyInterval = 'RestrictWriteReplyInterval',
}

export const MAX_REPLY_REPORT_REASON_LENGTH = 500;

export enum ReplyReportReasonType {
  RepeatedlySameMessage = 'RepeatedlySameMessage',
  SoullessMessage = 'SoullessMessage',
  AuthorObstruction = 'AuthorObstruction',
  Slander = 'Slander',
  Spam = 'Spam',
  SexualHarassment = 'SexualHarassment',
  ExposurePersonalInformation = 'ExposurePersonalInformation',
  CopyrightInfringement = 'CopyrightInfringement',
  Other = 'Other',
}

export enum ReplyBlockedType {
  BySystem = 'BySystem',
  ByAdmin = 'ByAdmin',
}
